$(document).ready(function() {
    $('.static-reviews').on('click', function() {
        var targetId = $(this).data('target-id');
        $('html, body').animate({
            scrollTop: $(targetId).offset().top
        }, 1000); // Duration of scroll animation in milliseconds
    });
});